import Skeleton from '@material-ui/lab/Skeleton';
import classNames from 'clsx';
import React from 'react';

import styles from './SkeletonList.scss';

interface Props {
  className?: string;
  skeletonSizes: string[];
  height?: number | string;
}

const SkeletonList = ({ className, skeletonSizes, height }: Props) => (
  <ul className={classNames(styles.skeletonList, className)}>
    {skeletonSizes.map((w, i) => (
      <li key={w + i}>
        <Skeleton variant="rect" height={height || 18} width={w} />
      </li>
    ))}
  </ul>
);

export default SkeletonList;
